import { browserHistory } from "react-router";
import {confirm} from 'util/confirm'
import {alert} from 'util/alert'
import {fetchClassroom} from 'containers/pages/Classroom/ducks'
import deleteClassroom from 'controllers/classroom/deleteClassroom'
import CreateClassroomModal from 'template/Modals/CreateClassroom'
import __R, { userCan } from 'containers/__R'

export default function() {
  return getDefaultTableSettings.call(this);
}

function getDefaultTableSettings() {
  let TabComponent = this;
  let {dispatch} = this.props

  return [
    {
      title: __('Edit', 'student'),
      onClick: ({trData: classroom}) => {
        CreateClassroomModal({mode: 'update', data: classroom})
      },
      isDisabled: (opts) => {
        return !userCan('edit_classroom')
      }
    },
    {
      title: __("Delete", "classroom"),
      onClick: ({trData: classroom}) => {
        confirm(__('Proceed to delete classroom?', 'classroom'), __("Delete", "classroom"))
        .then(() => {
          deleteClassroom(classroom.school_classroom_id)
          .then((result) => {
            const schoolId = localStorage.getItem('schoolId')
            this.props.fetchClassroom({schoolId})
          })
          .catch((err)=>{
            console.error(err);
          });
        })
        .catch((err)=>{
          console.error(err);
        });
      },
      isDisabled: (opts) => {
        return !userCan('delete_classroom')
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/containers/pages/Classroom/table-settings.js